import React from 'react';
import {bool, func, object} from 'prop-types';
import DocumentTitle from 'react-document-title';
import {Container} from 'semantic-ui-react';
import {injectIntl} from 'react-intl';
import partial from 'lodash/partial';
import isEmpty from 'lodash/isEmpty';
import StatusModal from 'components/common/StatusModal';
import PrizeSummary from 'components/prizes/PrizeSummary';
import ResourceAccordion from 'components/common/ResourceAccordion';
import SecretSonicSpinner from 'components/common/SecretSonicSpinner';
import AutoSaveResourceForm from 'components/forms/AutoSaveResourceForm';
import ImageEditModalContainer from 'pages/Images/ImageEditModalContainer';
import AutoSaveComponents from 'components/forms/Component Sets/AutoSaveComponents';
import UploadOriginalEditImageModalContainer from 'pages/Images/UploadOriginalEditImageModalContainer';
import PrizeDrawInfoContainer from './PrizeDrawInfoContainer';
import editPrizeConfig from './editPrizeConfig';

const customComponents = {
  ...AutoSaveComponents,
  drawInfo: PrizeDrawInfoContainer
};

const EditPrizePage = props => {
  const isLoading = isEmpty(props.prize);
  const title = isLoading ? props.intl.formatMessage({id: 'loading.prize'}) : props.prize.title;

  return (
    <DocumentTitle title={title}>
      <React.Fragment>
        <Container text>
          {isLoading ? <SecretSonicSpinner message={title} /> : (
            <div className='db-edit-prize-page'>
              <PrizeSummary
                prize={props.prize}
                errors={props.errors}
                userCanPublish={props.userCanPublishPrizes}
                publishPrize={partial(props.publishPrize, props.prize.id)} />
              <AutoSaveResourceForm
                components={customComponents}
                reducerKey={props.reducerKey}
                resource={props.prize}
                config={editPrizeConfig}
                staticRender={true}
                idPath='resource.resourceId.id'
                openSection={props.openSection}
                sectionWrapper={ResourceAccordion} />
              <UploadOriginalEditImageModalContainer />
              <ImageEditModalContainer />
            </div>
          )}
        </Container>
        {props.isPublishPrizeModalOpen && (
          <StatusModal
            isOpen={props.isPublishPrizeModalOpen}
            onClose={props.closePublishPrizeModal}
            className='publish-prize-modal'
            size='tiny'
            success={props.prizeWasPublished}
            errorKeys={props.prizePublishErrors}
            errorHeaderKey='error'
            errorMessageKey='publish.modal.header.error'
            successHeaderKey='success'
            successMessageKey='publish.modal.header.success' />
        )}
      </React.Fragment>
    </DocumentTitle>
  );
};

EditPrizePage.propTypes = {
  userCanPublishPrizes: bool.isRequired,
  publishPrize: func.isRequired,
  prize: object
};

export default injectIntl(EditPrizePage);



// WEBPACK FOOTER //
// ./public/pages/EditPrize/EditPrizePage.jsx